// // //@ts-nocheck
// // // PipelineContainer.tsx
// // import React, { useCallback, useEffect, useState } from 'react';
// // import { useParams } from 'react-router-dom';
// // import { useAppDispatch } from '../../app/hooks';
// // import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
// // import JobPipelineDetails from './HiringPipelineDetails';
// // import { toast } from 'sonner';
// // import JobPipelineStagesDetails from './HiringPipelineStagesDetails';

// // interface InvitedByMember {
// //   created_at: string;
// //   display_name: string;
// //   email: string;
// //   id: number;
// //   name: string;
// //   profile_pic: string;
// //   role: string;
// //   status: string;
// // }

// // interface PipelineData {
// //   user_id: number;
// //   invited_by: number;
// //   // Add other required fields
// // }

// // const HiringPipelineContainer: React.FC = () => {
// //   const [loading, setLoading] = useState(true);
// //   const [pipelineData, setPipelineData] = useState<InvitedByMember[] | null>(null);
// //   const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
// //   const dispatch = useAppDispatch();
// //   const [pipelineDataDetails, setPipelineDataDetails] = useState<any>(null);

// //   const processDataWithInvitedMembers = (data: PipelineData[]) => {
// //     const localStorageData = JSON.parse(localStorage.getItem('baseMembersDetails') || '{}');
// //     const baseMembers = localStorageData?.data?.baseMembers || [];

// //     // Map through pipeline data and return only invitedByMember information
// //     return data.map(item => {
// //       const invitedByMember = baseMembers.find(
// //         (member: any) => member.id === item.user_id
// //       );


// //       if (!invitedByMember) {
// //         return null;
// //       }

// //       return {
// //         created_at: invitedByMember.created_at,
// //         display_name: invitedByMember.display_name,
// //         email: invitedByMember.email,
// //         id: invitedByMember.id,
// //         name: invitedByMember.name,
// //         profile_pic: invitedByMember.profile_pic,
// //         role: item.role,
// //         status: invitedByMember.status,
// //         team_member_id: item.id,
// //         user_id: item.user_id,
// //         team_id: item.team_id,
// //         stage_id: item.stage_id
// //       };
// //     }).filter(Boolean); // Remove any null values
// //   };


// //   const fetchPipelineData = useCallback(async () => {
// //     if (!baseId || !jobId) {
// //       toast.error("Invalid Base ID or Job ID");
// //       setLoading(false);
// //       return;
// //     }
// //     try {
// //       const response = await dispatch(
// //         fetchJobPipelineDetailsData({
// //           baseId: Number(baseId),
// //           JobId: jobId
// //         })
// //       );
// //       if (response.meta.requestStatus === 'fulfilled' && response.payload?.data) {
// //         const rawPipelineData = response.payload.data.teamMembers;
// //         const invitedByMembersOnly = processDataWithInvitedMembers(rawPipelineData);
// //         setPipelineData(invitedByMembersOnly);
// //         setPipelineDataDetails(response.payload.data);
// //       }
// //     } catch (error) {
// //       toast.error("Failed to fetch pipeline details");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [baseId, jobId, dispatch]);

// //   useEffect(() => {
// //     fetchPipelineData();
// //   }, [baseId, jobId]);

// //   // Custom setPipelineData handler that will trigger a re-render
// //   const handleSetPipelineData = useCallback((newData: any) => {
// //     setPipelineData(newData);
// //     setPipelineDataDetails(newData);
// //   }, []);


// //   if (loading) {
// //     return (
// //       <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
// //         <div className="simple-spinner-loader">
// //           <span></span>
// //         </div>
// //       </div>
// //     );
// //   }
// // console.log(pipelineData,"hfjdsf gfds>>>>>>>>>>");
// // console.log(pipelineDataDetails,"hfjdsf gfds>>>>>>>>>>");


// //   return (
// //     <>
// //       {pipelineData && Array.isArray(pipelineData) && pipelineData?.length > 0 ? (
// //         <JobPipelineStagesDetails
// //           pipelineData={pipelineData}
// //           setPipelineData={setPipelineData}
// //           pipelineDataDetails={pipelineDataDetails}
// //           setPipelineDataDetails={setPipelineDataDetails}
// //         />
// //       ) : (
// //         <JobPipelineDetails
// //           pipelineData={pipelineData}
// //           setPipelineData={setPipelineData}
// //           setPipelineDataDetails={setPipelineDataDetails}
// //         />
// //       )}
// //     </>
// //   );
// // };

// // export default HiringPipelineContainer;

// //@ts-nocheck
// // PipelineContainer.tsx
// import React, { useCallback, useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { useAppDispatch } from '../../app/hooks';
// import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
// import JobPipelineDetails from './HiringPipelineDetails';
// import { toast } from 'sonner';
// import JobPipelineStagesDetails from './HiringPipelineStagesDetails';
// import { log } from 'node:console';

// interface InvitedByMember {
//   created_at: string;
//   display_name: string;
//   email: string;
//   id: number;
//   name: string;
//   profile_pic: string;
//   role: string;
//   status: string;
//   team_member_id?: number;
//   user_id?: number;
//   team_id?: number;
//   stage_id?: number;
// }

// interface PipelineData {
//   user_id: number;
//   invited_by: number;
//   id: number;
//   team_id?: number;
//   stage_id?: number;
//   role?: string;
// }

// const HiringPipelineContainer: React.FC = () => {
//   const [loading, setLoading] = useState(true);
//   const [pipelineData, setPipelineData] = useState<InvitedByMember[] | null>(null);
//   const [pipelineDataDetails, setPipelineDataDetails] = useState<any>(null);
//   const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
//   const dispatch = useAppDispatch();

//   const processDataWithInvitedMembers = (data: PipelineData[]) => {
//     const localStorageData = JSON.parse(localStorage.getItem('baseMembersDetails') || '{}');
//     const baseMembers = localStorageData?.data?.baseMembers || [];

//     return data.map(item => {
//       const invitedByMember = baseMembers.find(
//         (member: any) => member.id === item.user_id
//       );

//       if (!invitedByMember) {
//         return null;
//       }

//       return {
//         created_at: invitedByMember.created_at,
//         display_name: invitedByMember.display_name,
//         email: invitedByMember.email,
//         id: invitedByMember.id,
//         name: invitedByMember.name,
//         profile_pic: invitedByMember.profile_pic,
//         role: item.role,
//         status: invitedByMember.status,
//         team_member_id: item.id,
//         user_id: item.user_id,
//         team_id: item.team_id,
//         stage_id: item.stage_id
//       };
//     }).filter(Boolean);
//   };

//   const fetchPipelineData = useCallback(async () => {
//     if (!baseId || !jobId) {
//       toast.error("Invalid Base ID or Job ID");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await dispatch(
//         fetchJobPipelineDetailsData({
//           baseId: Number(baseId),
//           JobId: jobId
//         })
//       );

//       if (response.meta.requestStatus === 'fulfilled' && response.payload?.data) {
//         const rawPipelineData = response.payload.data.teamMembers;
//         const processedData = processDataWithInvitedMembers(rawPipelineData);  
//         setPipelineData(processedData);
//         setPipelineDataDetails(response.payload.data);
//       }
//     } catch (error) {
//       console.error("Error fetching pipeline details:", error);
//       toast.error("Failed to fetch pipeline details");
//     } finally {
//       setLoading(false);
//     }
//   }, [baseId, jobId, dispatch, processDataWithInvitedMembers]);

//   useEffect(() => {
//     fetchPipelineData();
//   }, [fetchPipelineData]);

//   const handleSetPipelineData = useCallback((newData: any) => {
//     if (newData?.teamMembers) {
//       const processedData = processDataWithInvitedMembers(newData.teamMembers);
//       setPipelineData(processedData);
//       setPipelineDataDetails(newData);
//     } else {
//       setPipelineData(newData);
//     }
//     fetchPipelineData(); // Refresh the data
//   }, [fetchPipelineData, processDataWithInvitedMembers]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
//         <div className="simple-spinner-loader">
//           <span></span>
//         </div>
//       </div>
//     );
//   }

//   const hasPipelineData = pipelineData &&
//     Array.isArray(pipelineData) &&
//     pipelineData.length > 0;
//     const hasPipelineDataDetails = pipelineDataDetails && Object.keys(pipelineDataDetails).length > 0;
// console.log(pipelineData,"piliedata");
// console.log(pipelineDataDetails, "piliedataDetails");
// console.log(hasPipelineDataDetails,"hasPipelineDataDetails");
// console.log(hasPipelineData,"hasPipelineData");


//   return (
//     <>
//       {hasPipelineDataDetails ? (
//         <JobPipelineStagesDetails
//           pipelineData={pipelineData}
//           setPipelineData={setPipelineData}
//           pipelineDataDetails={pipelineDataDetails}
//           setPipelineDataDetails={setPipelineDataDetails}
//         />
//       ) : (
//         <JobPipelineDetails
//           pipelineData={pipelineData}
//           setPipelineData={setPipelineData}
//           setPipelineDataDetails={setPipelineDataDetails}
//         />
//       )}
//     </>
//   );
// };

// export default HiringPipelineContainer;
//@ts-nocheck
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../app/hooks';
import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
import JobPipelineDetails from './HiringPipelineDetails';
import { toast } from 'sonner';
import JobPipelineStagesDetails from './HiringPipelineStagesDetails';

interface InvitedByMember {
  created_at: string;
  display_name: string;
  email: string;
  id: number;
  name: string;
  profile_pic: string;
  role: string;
  status: string;
  team_member_id?: number;
  user_id?: number;
  team_id?: number;
  stage_id?: number;
}

interface PipelineData {
  user_id: number;
  invited_by: number;
  id: number;
  team_id?: number;
  stage_id?: number;
  role?: string;
}

const HiringPipelineContainer: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [pipelineData, setPipelineData] = useState<InvitedByMember[] | null>(null);
  const [pipelineDataDetails, setPipelineDataDetails] = useState<any>(null);
  const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
  const dispatch = useAppDispatch();
  const [saveTeamId, setSaveTeamId] = useState(null)

  const processDataWithInvitedMembers = useCallback((data: PipelineData[]) => {
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];


    return data.map(item => {
      const invitedByMember = baseMembers.find(
        (member: any) => member.user_id === item.user_id
      );

      if (!invitedByMember) {
        return null;
      }

      return {
        created_at: invitedByMember.created_at,
        display_name: invitedByMember.display_name,
        email: invitedByMember.email,
        id: invitedByMember.id,
        name: invitedByMember.name,
        profile_pic: invitedByMember.profile_pic,
        role: item.role,
        status: invitedByMember.status,
        team_member_id: item.id,
        user_id: item.user_id,
        team_id: item.team_id,
        stage_id: item.stage_id
      };
    }).filter(Boolean);
  }, []);

  const fetchPipelineData = useCallback(async () => {
    if (!baseId || !jobId) {
      toast.error("Invalid Base ID or Job ID");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await dispatch(
        fetchJobPipelineDetailsData({
          baseId: Number(baseId),
          JobId: jobId
        })
      );

      if (response.meta.requestStatus === 'fulfilled' && response.payload?.data) {
        setSaveTeamId(response.payload.data)
        const rawPipelineData = response.payload.data.teamMembers;

        localStorage.setItem('jobByHiringTeamMembers', JSON.stringify(rawPipelineData))
        const processedData = processDataWithInvitedMembers(rawPipelineData);
        setPipelineData(processedData);
        setPipelineDataDetails(response.payload.data);
      }
    } catch (error) {
      console.error("Error fetching pipeline details:", error);
      toast.error("Failed to fetch pipeline details");
    } finally {
      setLoading(false);
    }
  }, [baseId, jobId, dispatch, processDataWithInvitedMembers]);

  // Initial data fetch
  useEffect(() => {
    fetchPipelineData();
  }, [fetchPipelineData]);

  // Add a second useEffect to handle immediate updates after job creation
  // useEffect(() => {
  //   if (jobId && (!pipelineData || pipelineData.length === 0)) {
  //     // const timeoutId = setTimeout(() => {
  //     //   fetchPipelineData();
  //     // }, 1000); // Add a small delay to ensure the backend has processed the job creation

  //     return () => clearTimeout(timeoutId);
  //   }
  // }, [jobId, pipelineData, fetchPipelineData]);

  const handleSetPipelineData = useCallback(async (newData: any) => {
    try {
      if (newData?.teamMembers) {
        const processedData = processDataWithInvitedMembers(newData.teamMembers);
        setPipelineData(processedData);
        setPipelineDataDetails(newData);
      } else if (newData) {
        // If we receive new data without team members structure
        setPipelineData(prev => {
          const dataToAdd = Array.isArray(newData) ? newData : [newData];
          return [...(prev || []), ...dataToAdd];
        });
      }

      // Always fetch fresh data after state updates
      await fetchPipelineData();
    } catch (error) {
      console.error("Error handling pipeline data update:", error);
      toast.error("Failed to update pipeline data");
    }
  }, [fetchPipelineData, processDataWithInvitedMembers]);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
        <div className="simple-spinner-loader">
          <span></span>
        </div>
      </div>
    );
  }

  const hasPipelineDataDetails = pipelineDataDetails.teamMembers && Object.keys(pipelineDataDetails.teamMembers).length > 0;


  return (
    <>
      {hasPipelineDataDetails ? (
        <JobPipelineStagesDetails
          pipelineData={pipelineData}
          setPipelineData={setPipelineData}
          pipelineDataDetails={pipelineDataDetails}
          setPipelineDataDetails={setPipelineDataDetails}
          saveTeamId={saveTeamId}
        />
      ) : (
        <JobPipelineDetails
          pipelineData={pipelineData}
          setPipelineData={setPipelineData}
          setPipelineDataDetails={setPipelineDataDetails}
        />
      )}
    </>
  );
};

export default HiringPipelineContainer;


// import React, { useCallback, useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { useAppDispatch } from '../../app/hooks';
// import { fetchJobPipelineDetailsData } from '../../features/hiringpipeline/hiringPipelineSlice';
// import JobPipelineDetails from './HiringPipelineDetails';
// import { toast } from 'sonner';
// import JobPipelineStagesDetails from './HiringPipelineStagesDetails';

// interface InvitedByMember {
//   created_at: string;
//   display_name: string;
//   email: string;
//   id: number;
//   name: string;
//   profile_pic: string;
//   role: string;
//   status: string;
//   team_member_id?: number;
//   user_id?: number;
//   team_id?: number;
//   stage_id?: number;
// }

// interface PipelineData {
//   user_id: number;
//   invited_by: number;
//   id: number;
//   team_id?: number;
//   stage_id?: number;
//   role?: string;
// }

// const HiringPipelineContainer: React.FC = () => {
//   const [loading, setLoading] = useState(true);
//   const [pipelineData, setPipelineData] = useState<InvitedByMember[] | null>(null);
//   const [pipelineDataDetails, setPipelineDataDetails] = useState<any>(null);
//   const [isInitialLoad, setIsInitialLoad] = useState(true);
//   const { baseId, jobId } = useParams<{ baseId: string; jobId: string }>();
//   const dispatch = useAppDispatch();

//   const processDataWithInvitedMembers = useCallback((data: PipelineData[]) => {
//     const localStorageData = JSON.parse(localStorage.getItem('baseMembersDetails') || '{}');
//     const baseMembers = localStorageData?.data?.baseMembers || [];

//     return data.map(item => {
//       const invitedByMember = baseMembers.find(
//         (member: any) => member.id === item.user_id
//       );

//       if (!invitedByMember) {
//         return null;
//       }

//       return {
//         created_at: invitedByMember.created_at,
//         display_name: invitedByMember.display_name,
//         email: invitedByMember.email,
//         id: invitedByMember.id,
//         name: invitedByMember.name,
//         profile_pic: invitedByMember.profile_pic,
//         role: item.role,
//         status: invitedByMember.status,
//         team_member_id: item.id,
//         user_id: item.user_id,
//         team_id: item.team_id,
//         stage_id: item.stage_id
//       };
//     }).filter(Boolean);
//   }, []);

//   const fetchPipelineData = useCallback(async () => {
//     if (!baseId || !jobId) {
//       toast.error("Invalid Base ID or Job ID");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await dispatch(
//         fetchJobPipelineDetailsData({
//           baseId: Number(baseId),
//           JobId: jobId
//         })
//       );

//       if (response.meta.requestStatus === 'fulfilled' && response.payload?.data) {
//         const rawPipelineData = response.payload.data.teamMembers;
//         const processedData = processDataWithInvitedMembers(rawPipelineData);  
//         setPipelineData(processedData);
//         setPipelineDataDetails(response.payload.data);
//       }
//     } catch (error) {
//       console.error("Error fetching pipeline details:", error);
//       toast.error("Failed to fetch pipeline details");
//     } finally {
//       setLoading(false);
//       setIsInitialLoad(false);
//     }
//   }, [baseId, jobId, dispatch, processDataWithInvitedMembers]);

//   useEffect(() => {
//     if (isInitialLoad) {
//       fetchPipelineData();
//     }
//   }, [fetchPipelineData, isInitialLoad]);

//   const handleSetPipelineData = useCallback(async (newData: any) => {
//     try {
//       if (newData?.teamMembers) {
//         const processedData = processDataWithInvitedMembers(newData.teamMembers);
//         setPipelineData(processedData);
//         setPipelineDataDetails(newData);
//       } else if (newData) {
//         setPipelineData(prev => {
//           const dataToAdd = Array.isArray(newData) ? newData : [newData];
//           return [...(prev || []), ...dataToAdd];
//         });
//         // Only fetch new data if we're updating with new pipeline data
//         await fetchPipelineData();
//       }
//     } catch (error) {
//       console.error("Error handling pipeline data update:", error);
//       toast.error("Failed to update pipeline data");
//     }
//   }, [fetchPipelineData, processDataWithInvitedMembers]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-[calc(100vh_-_5rem)]">
//         <div className="simple-spinner-loader">
//           <span></span>
//         </div>
//       </div>
//     );
//   }

//   const hasPipelineDataDetails = pipelineDataDetails && Object.keys(pipelineDataDetails).length > 0;

//   return (
//     <>
//       {hasPipelineDataDetails ? (
//         <JobPipelineStagesDetails
//           pipelineData={pipelineData}
//           setPipelineData={setPipelineData}
//           pipelineDataDetails={pipelineDataDetails}
//           setPipelineDataDetails={setPipelineDataDetails}
//         />
//       ) : (
//         <JobPipelineDetails
//           pipelineData={pipelineData}
//           setPipelineData={setPipelineData}
//           setPipelineDataDetails={setPipelineDataDetails}
//         />
//       )}
//     </>
//   );
// };

// export default HiringPipelineContainer;